import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.css";
// Import Bootstrap JS
import "bootstrap";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
// Import our custom theme CSS
import "./assets/css/theme.css";
// Import Auth0 plugin
import { createAuth0 } from '@auth0/auth0-vue';
import { configureAuth0Client } from './services/auth0-client';
// Import Vue I18n
import { createI18n } from 'vue-i18n';
import enMessages from './locales/en.json';
import itMessages from './locales/it.json';

// Get preferred language from localStorage or browser settings
const getPreferredLanguage = () => {
  // Check localStorage first
  const storedLang = localStorage.getItem('language');
  if (storedLang) {
    return storedLang;
  }
  
  // If no stored preference, detect from browser
  const browserLang = navigator.language.split('-')[0];
  return ['en', 'it'].includes(browserLang) ? browserLang : 'en';
};

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  globalInjection: true, // Inject $t, $d, etc. into all Vue components
  locale: getPreferredLanguage(),
  fallbackLocale: 'en',
  messages: {
    en: enMessages,
    it: itMessages
  }
});

const auth0Plugin = createAuth0({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: process.env.VUE_APP_CALLBACK_URL || (window.location.origin + '/callback'),
    audience: process.env.VUE_APP_AUTH0_AUDIENCE
  }
});
configureAuth0Client(auth0Plugin);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(i18n); // Register i18n instance
appInstance.use(auth0Plugin);

appInstance.mount("#app");
